import MenuRow from './_menu-row.js'

export default {
  name: 'SportTabSelector',
  values: {
    tabs: {
      configSet: MenuRow,
      configValues: {
        style: {
          container: {
            width: 'auto',
          },
        },
        item: {
          unselected: {
            style: {
              base: {
                minWidth: '80px',
              },
            },
          },
          selected: {
            style: {
              base: {
                minWidth: '80px',
              },
            },
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
